<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active" @getMenuClick="getMenuClick"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="main-title">
           首页（截止至{{sessionInfo.endtime_company}}）
        </div>
        
       
        <!-- 展商信息 -->
        <!-- <div class="ex-main">欢迎参加BCEIA2024!此系统将协助您完成参展前的一系列准备工作，请务必在各项截止日期前完成！</div> -->
        <el-row>
            <el-col  class="ex-infor pd">
              <div class="ex-wrap">
              <div class="ex-content" ref="infor">
                <div class="plan-wrap">
                  <div class="plan-title">请确认以下展商信息是否准确，有任何问题可联系您的展区负责人，确认无误请点击“开始”按钮</div>
                </div>
                <el-col :span="24">
                   <div class="ex-title">展商信息：</div>
                </el-col>
                <el-row>
                  <el-col :xl="10" :lg="10" :md="12" :sm="24" :xs="24">
                    <div class="ex-tinfor">
                      <span class="ex-left">展商名称：</span><span
                        class="ex-right"
                        >{{ userInfor.companyName }}</span
                      >
                    </div>
                    <div class="ex-tinfor">
                      <span class="ex-left">登录名：</span><span class="ex-right">{{
                        userInfor.exhibitionArea
                      }}</span>
                    </div>
                    <div class="ex-tinfor">
                      <span class="ex-left">公司：</span><span class="ex-right">{{
                        userInfor.boothNo
                      }}</span>
                    </div>
                    <!-- <div class="ex-tinfor">
                      <span class="ex-left">展馆号</span>：<span class="ex-right">{{
                        userInfor.hallNo
                      }}</span>
                    </div> -->
                    <div class="ex-tinfor">
                      <span class="ex-left">展馆地址：</span><span
                        class="ex-right"
                        >{{ sessionInfo.address_company }}</span
                      >
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="6" :xs="24" :md="12" :sm="24">
                    <div class="ex-tinfor">
                      <span class="ex-left">搭建时间：</span><span
                        class="ex-right"
                        >{{ sessionInfo.build_time_1 }}</span
                      >
                    </div>
                    <div class="ex-tinfor">
                      <span class="ex-left">项目经理：</span><span
                        class="ex-right"
                        >谢金燕</span
                      >
                    </div>
                    <div class="ex-tinfor">
                      <span class="ex-left">联系电话：</span><span
                        class="ex-right"
                        >19273728273</span
                      >
                    </div>
                  </el-col>
                  <el-col :xl="6"  :lg="6" :xs="24"  :md="12" :sm="24">
                      <el-image
                         style="width: 120px; height: 120px"
                        v-if="userInfor.company_code"
                        :src="$imgOssUrl + userInfor.company_code"
                      ></el-image>
                    </el-col>

                </el-row>
              
              
              </div>
            </div>
            </el-col>
         
          <!-- <el-col :span="11">
            <div class="ex-wrap">
              <div
                class="ex-content ex-contact"
                :style="{ height: height + 'px' }"
              >
                <div class="ex-title">展区负责人联系方式：</div>
                <div class="ex-text mb0">
                  <div class="ex-tinfor">
                    <span class="ex-left">负责人姓名</span
                    >：<span class="ex-right">{{ userInfor.manage_name }}</span>
                  </div>
                  <div class="ex-tinfor">
                    <span class="ex-left">联系电话</span
                    >：<span class="ex-right">{{ userInfor.manage_mobile }}</span>
                  </div>
                  <div class="ex-tinfor mb0">
                    <span class="ex-left">工作时间</span
                    >：<span class="ex-right">{{ userInfor.work_time }}</span>
                  </div>
                </div>
                <el-image
                  class="code-img"
                  v-if="userInfor.company_code"
                  :src="$imgOssUrl + userInfor.company_code"
                ></el-image>
              </div>
            </div>
          </el-col> -->
        </el-row>
        <!-- 富文本信息 -->
        <div class="rich-infor pd" v-if="content" v-html="content"></div>
        <el-button @click="next">开始</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { sessionInfo, getDetail } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "home",
  data() {
    return {
      loading: false,
      active: 0,
      stepList: [],
      emailIcon: require("../assets/icon_message.png"),
      userInfor: {},
      content: "",
      height: "",
      stepStatus: "",
      sessionInfo: {},
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getContent(this.id);
    this.getSession();
    // 获取缓存的展商信息、展区联系方式
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    // 进度
    // this.getStepList("top");
    this.userInfor = userdata.datainfo; // 展商信息
    console.log(this.userInfor, "=====userInfor");
    setTimeout(() => {
      this.height = this.$refs.infor.clientHeight;
    }, 0);
  },
  created() {},
  methods: {
    //获取navmenu组件传递过来的菜单列表数据
    getMenuClick(val) {
      this.stepList = val;
      this.$forceUpdate();
    },
 
    //  获取内容
    getContent(id) {
      this.loading = true;
      getDetail({ id })
        .then((res) => {
          //console.log(res, "======菜单进度");
          this.loading = false;
          if (res.code == 200) {
            let { data } = res.data;
            if (data[0].step) {
              this.content = data[0].step.app_introduction;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //基本信息
    getSession() {
      sessionInfo()
        .then((res) => {
          //console.log(res.data, '======getSession')
          if (res.code == 200) {
            this.sessionInfo = res.data;
          }
        })
        .catch((err) => {});
    },
    // 步骤条点击事件
    change(item) {
      if (item.state == "wait" && item.skip == undefined) {
        return false;
      }
      let { link_url, menu_title, id } = item;
      if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
        this.$router.push({
          path: link_url,
          query: {
            id: id,
            title: menu_title,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
          query: {
            id: id,
          },
        });
      }
    },
    // 点击开始
    next() {
     
      this.active = this.active + 1;
      let { link_url, menu_title, id } = this.stepList[this.active];
      if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
        this.$router.push({
          path: link_url,
          query: {
            id: id,
            title: menu_title,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
          query: {
            id: id,
          },
        });
      }
    }, 
    // 点击最新消息
    toMessage() {
      this.$router.push({
        path: "/messageList",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mb0 {
  margin-bottom: 0 !important;
}
.plan-wrap {
  margin-top: 37px;
  .plan-title{
    font-size: 18px;
    font-weight: 500;
    color: #FF862A;
    line-height: 30px;
    margin-bottom: 20px;
  }
  // 标题部分
  .plan-top {
    display: flex;
    align-items: center;
    color: #2c2c2e;
    .title {
      font-size: 20px;
      font-weight: 600;
      margin-right: 120px;
    }
    .plan-status {
      height: 28px;
      width: 369px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      border-radius: 16px;
      border: 1px solid #b8b8b8;
      .plan-item {
        font-size: 15px;
        span {
          width: 9px;
          height: 9px;
          margin-right: 10px;
          display: inline-block;
          background: #c7c7cc;
        }
        .finish-icon {
          background: #52c41a;
        }
        .verify-icon {
          background: #faad14;
        }
        .fail-icon {
          background: #ff4d4f;
        }
        .skip-icon{
          background: #5DE6DD;
        }
      }
    }
  }
  // 步骤部分
  .plan-step {
    display: flex;
    margin: 20px auto 42px;
    .plan-item {
      // width: 172px;
      flex: 1;
      // height: 80px;
      height: 65px;
      color: #fff;
      cursor: inherit;
      font-size: 12px;
      padding: 14px 19px 0 0;
      text-align: center;
      box-sizing: border-box;
      background: url("../assets/icon_gray.jpg") no-repeat;
      background-size: 100% 100%;
      .title {
        width: 65px;
        font-size: 13px;
        font-weight: 500;
        margin: 0 auto;
        padding-bottom: 5px;
        margin-bottom: 5px;
        border-bottom: 1px solid #fff;
      }
      &:last-child{
        padding-right: 10px;
        padding-left: 9px;
      }
    }
    .plan-item:hover {
      transform: scale(1.1);
      position: relative;
      z-index: 999;
      padding-right: 10px;
      padding-left: 9px;
    }
    .marLeft {
      margin-left: -36px;
      position: relative;
      z-index: 9;
    }
    // 审核中
    .process {
      cursor: pointer;
      background: url("../assets/icon_verify.jpg") no-repeat;
      background-size: 100% 100%;
    }
    // 已完成
    .finish {
      cursor: pointer;
      background: url("../assets/icon_finish.jpg") no-repeat;
      background-size: 100% 100%;
    }
    // 未通过
    .error {
      cursor: pointer;
      background: url("../assets/icon_fail.jpg") no-repeat;
      background-size: 100% 100%;
    }
    // 已跳过
    .skip {
      cursor: pointer;
      background: url("../assets/icon_skip.jpg") no-repeat;
      background-size: 100% 100%;
    }
    .cursor{
      cursor: pointer;
    }
  }
  // 最新消息
  .message {
    width: 750px;
    height: 54px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    color: #2c2c2e;
    padding: 0 27px;
    box-sizing: border-box;
    background: #ebf0fc;
    border-radius: 29px;
    .email-icon {
      width: 28px;
      height: 21px;
      
    }
    .message-content {
      flex: 1;
      font-size: 20px;
      color: #2c2c2e;
      margin-left: 16px;
      .message-text {
        width: 600px;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: nowrap;
      }
    }
  }
}
// 展商信息
.ex-main{
  color: #333;
  font-size: 16px;
  line-height: 28px;
  padding-top: 20px;
  padding-bottom: 5px;
  border-top: 10px solid #f2f4f8;
}
.ex-infor {
    
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
      background:#fff;
      border-radius: 8px;
  padding-bottom: 30px;
  .ex-wrap {
    
    color: #6F6F6F;
    .ex-title {
      width: 100%;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
    }
    .ex-content {
      
      > div {
        margin-bottom: 13px;
      }
      .ex-tinfor {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        margin-bottom: 22px;
        .ex-left {
          width: 90px;
          height: 20px;
          display: inline-block;
          text-align: justify;
          &:after {
            content: "";
            display: inline-block;
            width: 100%;
          }
        }
        .ex-right {
          flex: 1;
        }
      }
    }
    .ex-contact {
      display: flex;
      flex-wrap: wrap;
      // align-items: center;
      justify-content: space-between;
      .ex-text {
        flex: 1;
        > div {
          margin-bottom: 17px;
        }
        .ex-tinfor {
          .ex-left {
            width: 71px;
          }
        }
        .mb0 {
          margin-bottom: 0;
        }
      }
      .code-img {
        width: 120px !important;
        height: 120px !important;
      }
    }
  }
}
// 富文本信息
.rich-infor{
  margin-top: 30px;
  border-top: 10px solid #f2f4f8;
}
.rich-infor /deep/ img {
  max-width: 100%;
}
@media only screen and (max-width: 1280px) {
  
}
@media only screen and (max-width: 767px) {
  .plan-wrap{
    .plan-top,.plan-step{
      display: none;
    }
  }
  .main-title {
    font-size: 22px !important;
  }
  .plan-title{
    font-size: 14px !important;
  }
  .ex-title{
    font-size: 16px !important;
  }
  .ex-main{
    padding-top: 0;
    border: 0 none;
  }
  .ex-infor{
    font-size: 12px !important;
  }
  .content .el-button{
    font-size: 15px !important;
  }
  
  .content{
    // padding: initial !important;
    padding: 30px 0 130px 0;
    // margin: initial !important;
  }

  .content .el-button{
    bottom: 60px;
  }
  
  .ex-infor{
    padding-bottom: 130px !important;
    .el-col-11{
      width: 100%;
    }
    .ex-wrap{
      .ex-content{
        width: 100%;
        max-width: 100%;
      }
    }
  }
}

</style>